import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import NavigationBar from "@/components/shared/NavigationBar.vue";
import SegmentedControl from "@/components/shared/SegmentedControl.vue";
import FindLoginPassword from "@/views/login/FindLoginPassword.vue";
import Page from "@/components/shared/Page.vue";


const __default__ = {
  name: "FindLoginInfo",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

const currentSegmentIndex = ref(0);

const segmentedControl = ref<InstanceType<typeof SegmentedControl>>();

const contentsBody = ref<HTMLElement>();
let touchStartX = 0;
let touchEndX = 0;
const onTouchStart = (event: TouchEvent) => {
  touchStartX = event.changedTouches[0].screenX;
};
const onTouchEnd = (event: TouchEvent) => {
  touchEndX = event.changedTouches[0].screenX;
  if (Math.abs(touchEndX - touchStartX) < 30) {
    return;
  }
  currentSegmentIndex.value = touchEndX < touchStartX ? 1 : 0;
  segmentedControl.value?.changeSegmentIndex(currentSegmentIndex.value);
};

const __returned__ = { currentSegmentIndex, segmentedControl, contentsBody, get touchStartX() { return touchStartX }, set touchStartX(v) { touchStartX = v }, get touchEndX() { return touchEndX }, set touchEndX(v) { touchEndX = v }, onTouchStart, onTouchEnd, NavigationBar, FindLoginPassword, Page }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})